import { SMSSender } from 'modules/graphql/types';
import { TrackingDomain } from 'modules/mailDomains/types';

import { OS, PreviewType } from '../common/types';

/** Format SMS senders data into what is expected for options value in BasicSelect */
export const formatSMSSenders = (smsSenders: SMSSender[]) =>
  smsSenders.map((sender) => ({
    doubleLine: sender.phoneNumber,
    id: sender.id.toString(),
    label: sender.name,
    value: sender.id.toString(),
  }));

/** Format SMS senders data into what is expected for options value in FilterSelect */
export const formatTrackingDomains = (trackingDomains: TrackingDomain[]) =>
  trackingDomains.map(({ domain }: { domain: string }) => ({
    id: domain,
    label: domain,
    value: domain,
  }));

/**
 * Returns truncated SMS notification message (lock screen)
 * @see {@link https://support.airship.com/hc/en-us/articles/213491643-What-are-the-Maximum-Characters-for-Push-Notifications-}
 * @param {OS} selectedOs - enum for the OS being rendered
 * @param {string} [message] - any text string
 * @returns {string} truncated SMS (lock screen) notification message
 */
export const getNotificationMsg = (selectedOs: OS, message = '') => {
  const trimmedMsg = message.trim();
  const msgMax = selectedOs === OS.ios ? 150 : 40;
  return trimmedMsg.length > msgMax ? (
    <>{trimmedMsg.slice(0, msgMax).trim()}&hellip;</>
  ) : (
    trimmedMsg
  );
};

export const getFullMessage = (message: string, optOutDisclaimer: string) => {
  return optOutDisclaimer ? `${message}\n\n${optOutDisclaimer}` : message;
};

export const previewTypeOptions: (
  isContactCardUIEnabled: boolean,
  hasContactCard: boolean,
) => { id: string; label: PreviewType; value: PreviewType }[] = (
  isContactCardUIEnabled,
  hasContactCard,
) =>
  Object.entries(PreviewType)
    .filter((pair) => isContactCardUIEnabled || pair[0] !== 'contactCard')
    .map((pair) => ({
      id: pair[0],
      label: pair[1],
      value: pair[1],
      isDisabled: pair[0] === 'contactCard' && !hasContactCard,
    }));

export const tryParseJSONObject = (jsonString: string) => {
  try {
    const o = JSON.parse(jsonString);
    if (o && typeof o === 'object' && o.constructor.toString().indexOf('Object') > -1) {
      return o;
    }
  } catch (e) {
    return {};
  }

  return {};
};
